<button class="btn btn-warning btn-block" [disabled]="!isEnabled || isBlocked || isLocked" (click)="callAgainTicket()" title="{{ tooltipTitle }}" #button>
    <i class="fas fa-sync-alt" #icon></i>
    <span class="element-text">{{ 'console.again' | translate }}</span>
</button>
